import { Outlet } from 'react-router-dom';

export default function AuthLayout() {
  return (
    <div className="min-h-screen flex items-center justify-center py-6 px-4 sm:py-12 sm:px-6 lg:px-8 relative overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover grayscale"
      >
        <source src="/videos/bg-login.mp4" type="video/mp4" />
      </video>

      {/* Dark overlay with warm tone */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-blue/60 via-harvest-900/50 to-brand-blue/70" />

      {/* Content */}
      <div className="relative z-10 max-w-md w-full space-y-6 sm:space-y-8">
        <div className="bg-white/95 backdrop-blur-sm rounded-xl sm:rounded-2xl shadow-2xl p-5 sm:p-8 animate-scale-in">
          <div className="text-center mb-6 sm:mb-8">
            <img
              src="/images/bushel-view-logo.png"
              alt="Bushel View"
              className="w-auto mx-auto max-w-[200px] sm:max-w-[280px]"
            />
            <p className="mt-3 sm:mt-4 text-brand-dark-gray font-medium text-sm sm:text-base">Grain Marketing Manager</p>
          </div>
          <Outlet />
        </div>
        <p className="text-center text-xs sm:text-sm text-white/70">
          Powered by Logic Ag Marketing
        </p>
      </div>
    </div>
  );
}
